export var PARTNERS_PATH = '/partners/';
export var PARTNERS_CREATE_PATH = "".concat(PARTNERS_PATH, "create/");
export var PARTNERS_EDIT_PATH = "".concat(PARTNERS_PATH, ":id/modify");
export var MSP_PARTNERS_CREATE_PATH = "".concat(PARTNERS_PATH, "new");
export var MSP_PARTNER_DETAILS_PATH = "".concat(PARTNERS_PATH, ":uuid/:tab?");
export var getMspPartnerDetailsPath = function getMspPartnerDetailsPath(uuid) {
    return "".concat(PARTNERS_PATH).concat(uuid);
};
export var getMspPartnerBillingPath = function getMspPartnerBillingPath(uuid) {
    return "".concat(getMspPartnerDetailsPath(uuid), "/billing");
};
export var getMspPartnerOrganizationsPath = function getMspPartnerOrganizationsPath(uuid) {
    return "".concat(getMspPartnerDetailsPath(uuid), "/organizations");
};
export var getMspPartnerSfIntegrationPath = function getMspPartnerSfIntegrationPath(uuid) {
    return "".concat(getMspPartnerDetailsPath(uuid), "/sf-integration");
};
